module.exports = __webpack_public_path__ + "static/img/icon_org_apply.bdb5a5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/icon_org_apply.jpg
// module id = 2as2
// module chunks = 14